import { Form } from 'antd';
import styled from 'styled-components';

const BASE_RATE_PRODUCTS_CONSTANT = {
  wire_configuration: {
    value: 'WIRE'
  }
};

const BASE_RATE_MODE_CONSTANT = {
  upi: {
    value: 'UPI'
  },
  neft: {
    value: 'NEFT'
  },
  imps: {
    value: 'IMPS'
  },
  rtgs: {
    value: 'RTGS'
  }
};

const SettingsFormItemHorizontal = styled(Form.Item)`
  .ant-row.ant-form-item-row {
    flex-direction: row !important;
    margin-left: -10px;
  }

  .ant-form-item-label {
    white-space: nowrap;
    text-align: end;
  }

  .ant-form-item-control {
    flex: 1 1 0;
    min-width: 0;
    justify-content: center;
    margin-top: 10px;
  }

  .ant-form-item-label > label {
    height: 32px;
    margin: 8px !important;

    &::after {
      display: block;
      content: ' ';
      position: relative;
      margin-block: 0;
      margin-inline-start: 2px;
      margin-inline-end: 8px;
    }
  }
`;

const BASE_RATE_MIN_AMOUNT = 'min_amount';
const BASE_RATE_MAX_AMOUNT = 'max_amount';
const BASE_RATE_TYPE = 'base_rate_type';
const BASE_RATE_VALUE = 'base_rate_value';
const BASE_RATE_SLAB_KEY = 'slab';
const BASE_RATE_SLAB_ENABLE_KEY = 'is_enable';
const BASE_RATE_ENABLE = 'Enable';
const BASE_RATE_DISABLE = 'Disable';
const RUPEE_SIGN = '₹';
const INFINITY_SIGN = '∞';
const PERCENTAGE_SIGN = '%';
const PERCENTAGE = 'PERCENTAGE';

export {
  BASE_RATE_MODE_CONSTANT,
  BASE_RATE_PRODUCTS_CONSTANT,
  BASE_RATE_MIN_AMOUNT,
  BASE_RATE_MAX_AMOUNT,
  BASE_RATE_TYPE,
  BASE_RATE_VALUE,
  BASE_RATE_SLAB_KEY,
  BASE_RATE_SLAB_ENABLE_KEY,
  BASE_RATE_ENABLE,
  BASE_RATE_DISABLE,
  RUPEE_SIGN,
  PERCENTAGE_SIGN,
  PERCENTAGE,
  INFINITY_SIGN,
  SettingsFormItemHorizontal
};
